/** @jsxImportSource @emotion/react */
"use client";

import { forwardRef } from "react";

import type { ThemeType } from "../../../../../global/emotion";
import { spacing } from "../../../../../global/emotion";
import { Text } from "../../../_base/_core/Text/Text.emotion";
import { useFormField } from "./FormField.emotion";

export const FormMessage = forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ children, ...props }, ref) => {
  const { error, formMessageId } = useFormField();
  const body = error ? String(error?.message) : children;

  if (!body) {
    return null;
  }

  return (
    <Text
      ref={ref}
      type="detail"
      size="l"
      id={formMessageId}
      css={(theme: ThemeType) => ({
        color: theme.semanticColors.errorError,
        marginHorizontal: spacing.xs,
      })}
      {...props}
    >
      {body}
    </Text>
  );
});

FormMessage.displayName = "FormMessage";
